import Model from '../models/model'
import { loadScope } from './QuickSerchSocpeTable';

export const model = new Model({
	name: "ScopeRegionConfiguration",
	idProperty: '_id',
	allowImport: false,
	disableDelete: true,
	disableAdd: true,
	defaultSort: 'ManufacturerName ASC',
	showGridRefreshBtn: true,
	pageSize: 15,
	columns: [
		{ header: 'Manufacturer', field: 'ManufacturerName', width: 180, isNotformfield: true, headerFilter: true, lookup: 'ManufacturerName', eager: true, headerFilterProps: { label: 'Manufacturer', multiple: false }, standaloneHeaderFilter: true, readOnly: true },
		{ header: 'Manufacturer', field: 'ManufacturerName', width: 180, readOnly: true },
		{ header: 'ScopeType', field: 'ScopeType', width: 200, isNotformfield: true, headerFilter: true, lookup: loadScope('ScopeType'), dependsOn: ['ManufacturerName'], type: 'string', headerFilterProps: { label: 'scopeType', multiple: false }, standaloneHeaderFilter: true, readOnly: true },
		{ header: 'scopeType', field: 'ScopeType', width: 200, readOnly: true },
		{ header: 'ScopeModel', field: 'ScopeModel', width: 120, headerFilter: true, lookup: loadScope('ScopeModel'), dependsOn: ['ManufacturerName', 'ScopeType'], type: 'string', headerFilterProps: { label: 'ScopeModel', multiple: false }, standaloneHeaderFilter: true, readOnly: true },
		{ header: 'ScopeModel', field: 'ScopeModel', width: 120, isNotformfield: true, readOnly: true },
		{ header: 'RegionNameNew', field: 'RegionName', width: 400, type: 'string', isNotformfield: true },
		{ header: 'Published', field: 'Published', width: 150, isNotformfield: true, type: "boolean" },
	]
});
export default model.createFormBase();